export default class CategoriesEntity {
    constructor (data) {
        return data;
    }

}